import React from 'react'
import styled from 'styled-components'
import TextInput from 'components/TextInput'
import { color } from 'styles/colors'

export type Props = {
  isEditing: boolean
  value?: string | null
  onChangeCallback: (value: string) => void
  placeholder?: string
  maxLength?: number
  errorMessage?: string
}

const ConfigTextInput = ({ isEditing, value, onChangeCallback, placeholder, maxLength, errorMessage }: Props) => {
  return (
    <React.Fragment>
      {isEditing ? (
        <React.Fragment>
          <S.Input
            type="text"
            value={value ?? ''}
            placeholder={placeholder}
            maxLength={maxLength}
            aria-invalid={Boolean(errorMessage)}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              onChangeCallback(event.target.value)
            }
          />
          {errorMessage && (
            <S.ErrorMessage role="alert" aria-live="polite">
              {errorMessage}
            </S.ErrorMessage>
          )}
        </React.Fragment>
      ) : (value || '--')}
    </React.Fragment>
  )
}

export default ConfigTextInput

const S = {
  ErrorMessage: styled.span`
    color: ${color('errorMessage')};
    font-size: 13px;
    font-weight: bold;
  `,
  Input: styled(TextInput)`
    margin-bottom: 0;

    > input:first-of-type {
      font-weight: 700;
      font-size: 0.85rem;
      border-radius: 4px;
      line-height: 1;
      height: 26px;
      margin: 0;
      padding-top: 0;
      padding-bottom: 0;
    }
  `
}
